import sort, { stringSort } from "@domains/utils/sort";
import { MUTUAL_FUNDS_SCHEMES, MUTUAL_FUNDS_SCHEMES_APPLY_SORT, MUTUAL_FUNDS_SCHEMES_CLEAR_MSG, MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA, MUTUAL_FUNDS_SCHEMES_CLEAR_SORT, MUTUAL_FUNDS_SCHEMES_ERROR, MUTUAL_FUNDS_SCHEMES_HIDE_ERROR, MUTUAL_FUNDS_SCHEMES_PARAMS, MUTUAL_FUNDS_SCHEMES_START_LOADER, MUTUAL_FUNDS_SCHEMES_STOP_LOADER, MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER, MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER, MUTUAL_FUNDS_SCHEMES_UPDATE_MSG, MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA, MUTUAL_FUNDS_SCHEMES_UPDATE_SORTED_DATA, } from "../interface/iMutualFundsSchemes";
const initState = {
    mutualFundsSchemeList: [],
    paramsData: {},
    mutualFundsLoader: false,
    mutualFundsTableLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
    message: {
        msg: null,
        show: false,
        icon: null,
    },
    searchState: {
        searchData: "",
        data: [],
    },
    sortData: {
        sortState: [],
        sortRecord: {},
        data: [],
    },
};
const applySorting = (sortRecord, data, sortData) => {
    if (sortRecord.type && sortRecord.type === "string") {
        data = stringSort(data, sortRecord.key, sortRecord.order);
    }
    else {
        data = sort(data, sortRecord.key, sortRecord.order);
    }
    return { sortState: sortData, sortRecord: sortRecord, data: data };
};
const mutualFundsSchemes = (state = initState, action) => {
    var _a, _b, _c, _d;
    switch (action.type) {
        case MUTUAL_FUNDS_SCHEMES:
            return Object.assign(Object.assign({}, state), { mutualFundsSchemeList: action.payload.mutualFundsSchemes });
        case MUTUAL_FUNDS_SCHEMES_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case MUTUAL_FUNDS_SCHEMES_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case MUTUAL_FUNDS_SCHEMES_PARAMS:
            return Object.assign(Object.assign({}, state), { paramsData: (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.paramsData });
        case MUTUAL_FUNDS_SCHEMES_APPLY_SORT:
            return Object.assign(Object.assign({}, state), { sortData: applySorting((_b = action.payload) === null || _b === void 0 ? void 0 : _b.sortState.sortRecord, (_c = action.payload) === null || _c === void 0 ? void 0 : _c.sortState.data, (_d = action.payload) === null || _d === void 0 ? void 0 : _d.sortState.sortState) });
        case MUTUAL_FUNDS_SCHEMES_CLEAR_SORT:
            return Object.assign(Object.assign({}, state), { sortData: initState.sortData });
        case MUTUAL_FUNDS_SCHEMES_UPDATE_SORTED_DATA:
            state.sortData.data = action.payload.mutualFundsSchemes;
            return Object.assign({}, state);
        case MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA:
            return Object.assign(Object.assign({}, state), { searchState: action.payload.searchState });
        case MUTUAL_FUNDS_SCHEMES_UPDATE_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case MUTUAL_FUNDS_SCHEMES_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        case MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA:
            return Object.assign(Object.assign({}, state), { searchState: initState.searchState });
        case MUTUAL_FUNDS_SCHEMES_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        case MUTUAL_FUNDS_SCHEMES_START_LOADER:
            return Object.assign(Object.assign({}, state), { mutualFundsLoader: true });
        case MUTUAL_FUNDS_SCHEMES_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { mutualFundsLoader: false });
        case MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER:
            return Object.assign(Object.assign({}, state), { mutualFundsTableLoader: true });
        case MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { mutualFundsTableLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default mutualFundsSchemes;
